// Libs
import sptk from '../../libs/sptk';

class FiltersModule {
    constructor() {
        // ES6 Rebind
        this.onClickFilter = this.onClickFilter.bind(this);
        this.initialize();
    }

    initialize() {
        this.bindUI();
        this.bindEvents();

        this.filterTargets = [];

        this.initFilters();
    }

    bindUI() {
        this.ui = {};

        this.ui.$filters = document.querySelectorAll('.js-filter');
        this.ui.$filtersTargets = document.querySelectorAll('.js-filter-target');
    }

    bindEvents() {
        [].forEach.call(this.ui.$filters, item => {
            item.addEventListener('click', this.onClickFilter)
        });
    }

    unbindEvents() {
        [].forEach.call(this.ui.$filters, item => {
            item.removeEventListener('click', this.onClickFilter)
        });
    }


    destroy() {
        this.unbindEvents();
    }

    initFilters() {
        [].forEach.call(this.ui.$filtersTargets, item => {
            this.filterTargets.push({
                $el: item,
                type: item.getAttribute('data-type'),
                height: item.clientHeight
            })
        });

        this.currentFilterTarget = this.ui.$filters[0].parentElement;
    }

    onClickFilter(e) {
        e.preventDefault();
        const target = e.currentTarget;
        const filter = target.getAttribute('data-filter');

        this.removeFilter();

        if (filter !== '*') {
            this.filter(filter);
        } else {
            this.showAllTargets();
        }

        this.currentFilterTarget = target.parentElement;
        this.currentFilterTarget.classList.add('is-active');
    }

    filter(filter) {
        if (filter) {
            this.filterTargets.forEach(item => {
                if (item.type === filter) {
                    this.showTarget(item);
                } else {
                    item.$el.classList.add('is-filtered');
                    item.$el.style.height = 0;
                }
            })
        }

    }

    removeFilter() {
        if (this.currentFilterTarget) {
            this.currentFilterTarget.classList.remove('is-active');
        }
    }

    showAllTargets() {
        this.filterTargets.forEach(item => {
            this.showTarget(item);
        });
    }

    showTarget(item) {
        item.$el.classList.remove('is-filtered');
        item.$el.style.height = `${item.height}px`;
    }
}

export default FiltersModule;
